<template>
  <div ref="editor" />
</template>

<script>

import { css } from '@codemirror/lang-css'
import { basicSetup, EditorView } from 'codemirror'

export default {
  name: 'CssEditor',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    debounce: {
      type: Number,
      required: false,
      default: 100
    }
  },
  emits: ['update:model-value'],
  watch: {
    modelValue () {
      const currentValue = this.editor.state.doc.toString()
      if (this.modelValue === currentValue) return

      const endPosition = currentValue.length

      this.editor.dispatch({
        changes: {
          from: 0,
          to: endPosition,
          insert: this.modelValue
        }
      })
    }
  },
  mounted () {
    this.editor = new EditorView({
      doc: this.modelValue,
      extensions: [
        basicSetup,
        css(),
        EditorView.updateListener.of((v) => {
          if (v.docChanged) {
            if (this.debounceTimer) clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(
              () => {
                this.$emit('update:model-value', this.editor.state.doc.toString())
              },
              this.debounce
            )
          }
        })
      ],
      parent: this.$refs.editor
    })
  },
  unmounted () {
    this.editor.destroy()
  },
  methods: {
  }
}
</script>

<style lang="scss">
.cm-editor {
  max-height: 100%;
}
</style>
